import React from 'react';
import { FaRegSave } from 'react-icons/fa';

function SyncSave({ onSync, onCreateOffer, isSyncing, offerId, isReadOnly, isNewDealFlow, hasInitialSave, isIconOnly }) {
  // Icon-only mode: the disc button in the actions bar (always visible)
  if (isIconOnly) {
    const isDisabled = isSyncing || !offerId || isReadOnly;
    return (
      <button
        type="button"
        onClick={() => { if (!isDisabled) onSync(); }}
        className="inline-flex items-center justify-center text-company-main transition hover:text-company-main/80 disabled:text-black/30"
        title="Manual sync to Zoho"
        aria-label="Manual sync to Zoho"
        disabled={isDisabled}
      >
        <FaRegSave className="h-4 w-4" />
      </button>
    );
  }

  // New-deal flow: show "Create Offer" until initial save, then "Save Offer"
  const showCreateButton = isNewDealFlow && !hasInitialSave && !offerId;

  if (showCreateButton) {
    return (
      <button
        type="button"
        onClick={onCreateOffer}
        disabled={isSyncing}
        className="inline-flex items-center gap-2 rounded-md bg-company-main px-5 py-2.5 text-base font-semibold text-white shadow-lg transition hover:bg-company-main/90 disabled:opacity-50 animate-pulse"
        title="Create this offer in Zoho"
        aria-label="Create Offer"
      >
        {isSyncing ? 'Creating...' : 'Create Offer'}
      </button>
    );
  }

  // "Save Offer" button — always visible once offer exists
  const isDisabled = isSyncing || !offerId || isReadOnly;
  return (
    <button
      type="button"
      onClick={() => { if (!isDisabled) onSync(); }}
      className="inline-flex items-center gap-1.5 rounded bg-company-main px-3 py-1.5 text-sm font-medium text-white transition hover:bg-company-main/90 disabled:opacity-50"
      title="Save offer to Zoho"
      aria-label="Save Offer"
      disabled={isDisabled}
    >
      {isSyncing ? 'Saving...' : 'Save Offer'}
    </button>
  );
}

export default SyncSave;
